import { StringUtil } from "@mcleod/core";
import { AutogenLayoutBrokerageStatusCodeList } from "./autogen/AutogenLayoutBrokerageStatusCodeList";
import { Button, Label, TableRowDisplayEvent } from "@mcleod/components";

export class BrokerageStatusCodeList extends AutogenLayoutBrokerageStatusCodeList {

    override onLoad() {
        this.mainDataSource.orderBy = [{ field: "is_active", sort: "desc" }, {field: "descr", sort: "asc" }];
    }

    onRowDisplay(event: TableRowDisplayEvent) {

        const labelIsActive: Label = event.target.findComponentById("labelIsActive") as Label;
        const labelDisplayCallinScreen: Label = event.target.findComponentById("labelDisplayCallinScreen") as Label;
        const labelDisplayPortal: Label = event.target.findComponentById("labelDisplayPortal") as Label;
        const buttonOrderPlanningColor: Button = event.target.findComponentById("buttonOrderPlanningColor") as Button;
        const tableRow = event.getTableRow();

        if (tableRow.data != null) {
            const modelRow = tableRow.data;
            if (StringUtil.equalsIgnoreCase(modelRow.get("is_active"), "Y")) {
                labelIsActive.text = "Yes";
            }
            else
            {
                labelIsActive.text = "No";
            }

            if (StringUtil.equalsIgnoreCase(modelRow.get("display_callin_screen"), "Y")) {
                labelDisplayCallinScreen.text = "Yes";
            }
            else
            {
                labelDisplayCallinScreen.text = "No";
            }

            if (modelRow?.getBoolean("display_portal")) {
                labelDisplayPortal.text = "Yes";
            }
            else
            {
                labelDisplayPortal.text = "No";
            }

            const color = modelRow.get("planning_hex_color");
            if (!StringUtil.isEmptyString(color)) {
                buttonOrderPlanningColor.color = color;
                buttonOrderPlanningColor.visible = true;
            }
            else {
                buttonOrderPlanningColor.visible = false;
            }


        }
    }
}
